import React from 'react';
import PropTypes from 'prop-types';

import styles from './PackageSelect.module.scss';

const Package = ({ pkg, activePackage, handlePackageSelect }) => {
  const {
    pressReleaseListPrice,
  } = window.bulkPurchaseCodeCheckoutFlow;

  const isSelected = activePackage === pkg.pk;

  const buttonClasses = `${styles['package-button']} ${activePackage === pkg.pk ? styles['active-button'] : styles['inactive-button']}`;
  return (
    <div className={styles['package-wrapper']}>
      <button
        onClick={() => handlePackageSelect(pkg.pk, pkg.minimum_quantity)}
        className={buttonClasses}
        type="button"
        key={pkg.pk}
        aria-label={`${pkg.minimum_quantity} or more press releases package--currently ${
          activePackage === pkg.pk ? 'selected' : 'not selected'
        }`}
      >
        <input
          type="radio"
          id={pkg.display_name}
          name="package"
          value={pkg.pk}
          checked={activePackage === pkg.pk}
          tabIndex={-1}
          readOnly
        />
        <label
          htmlFor={pkg.display_name}
          className={`${styles['name-label']} ${isSelected ? styles['name-label--active'] : ''}`}
        >
          {pkg.display_name}
          {pkg.is_most_popular && (<span className={styles['most-popular-label']}> (Most Popular)</span>)}
        </label>
        <div className={styles['package-price']}>
          <span className={`${styles['discounted-price']} ${isSelected ? styles['discounted-price--active'] : ''}`}>
            {`$${pkg.price_per_press_release / 100}`}
          </span>{' '}
          <span className={styles['list-price']}>{`$${pressReleaseListPrice}`}</span>
          <div className={styles['price-text']}>per press release</div>
        </div>
      </button>
    </div>
  );
};

Package.propTypes = {
  pkg: PropTypes.shape({
    pk: PropTypes.number,
    minimum_quantity: PropTypes.number,
    price_per_press_release: PropTypes.number,
    is_best_value: PropTypes.bool,
    is_most_popular: PropTypes.bool,
    display_name: PropTypes.string,
  }).isRequired,
  activePackage: PropTypes.number.isRequired,
  handlePackageSelect: PropTypes.func.isRequired,
};

export default Package;
